import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { AdminTabClientCardComponent } from '../admin-tab-client-card/admin-tab-client-card.component';
import { Store } from '@ngrx/store';

@Component({
  selector: 'wil-admin-tab-client',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    ClipboardModule,
    AdminTabClientCardComponent
],
  templateUrl: './admin-tab-client.component.html',
  styleUrls: ['./admin-tab-client.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminTabClientComponent {
  private store = inject(Store);

  @Input() clients: ParticipantOutputWithLinksDto[] | null = [];
  @Input() isLoading = false;
  @Input() error: string | null = null;

  @Output() createClientClick = new EventEmitter<void>();
  @Output() retryLoadClick = new EventEmitter<void>();

  // Get clients sorted by creation date (newest first)
  public get sortedClients(): readonly ParticipantOutputWithLinksDto[] {
    const list = this.clients?.length ? [...this.clients] : [];
    return list.sort((a, b) => new Date(b.audit.createdAt).getTime() - new Date(a.audit.createdAt).getTime());
  }

  public onCreateClient(): void {
    this.createClientClick.emit();
  }

  public onRetryLoad(): void {
    this.retryLoadClick.emit();
  }

  public onCopyLink(link: ResolvedWheelLink): void {
    // The ClipboardModule will handle the actual copying
    console.log('Link copied:', link.linkUrl);
  }

  public formatLastSession(client: ParticipantOutputWithLinksDto): string {
    return client.lastContact ? new Date(client.lastContact).toLocaleDateString() : '—';
  }
}
